import { selectors } from "../add-element/cypressSelectors";
import { EditableResourceFields } from "../resources/modelTypes";
import { format as formatDate } from "date-fns";
import React from "react";

export const formatAddress = ({
  address1,
  address2,
  city,
  state,
  zipCode,
}: EditableResourceFields) => {
  // Return empty string if all required fields are null/undefined/empty
  if (!address1 && !city && !state && !zipCode) {
    return "";
  }

  // Filter and join the comma-separated parts: address1, address2?, city, state
  const addressParts = [address1, address2, city, state].filter(Boolean);

  let result = addressParts.join(", ");

  // Handle zipCode separately (space-separated from state)
  if (zipCode) {
    result += ` ${zipCode}`;
  }

  return result;
};

export const formatEventDate = (date: string) => {
  // incoming date format: 'MM/dd/yyyy'
  const [month, day, year] = date.split("/");

  if (!(day && month && year)) {
    return "";
  }

  const actualDate = new Date(Number(year), Number(month) - 1, Number(day));

  return formatDate(actualDate, "EEEE, MMMM d, yyyy");
};

export const formatEventTime = (date: string, time: string) => (
  <div>
    {date}
    <br />
    {time}
  </div>
);

export const getEventDateTimeComponent = (
  date: string | undefined,
  time: string | undefined,
  endDate: string | undefined,
  endTime: string | undefined,
) => {
  // Incoming date format: 'MM/dd/yyyy'

  // Date is required to be valued
  if (!date) {
    return null;
  }

  const formattedStartDate = formatEventDate(date);

  const startDateTime = time
    ? formatEventTime(formattedStartDate, time)
    : formattedStartDate;

  if (!endDate) {
    return (
      <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
        {startDateTime}
      </div>
    );
  }

  if (date === endDate && time !== endTime) {
    const timeRange = endTime ? (
      <span>
        <br />
        {time}
        {" - "}
        {endTime}
      </span>
    ) : (
      time
    );

    return (
      <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
        {`${formattedStartDate}`}
        {timeRange}
      </div>
    );
  }

  if (date !== endDate) {
    const formattedEndDate = formatEventDate(endDate);
    const endDateTime = endTime
      ? formatEventTime(formattedEndDate, endTime)
      : formattedEndDate;

    return (
      <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
        {startDateTime}
        -
        <br />
        {endDateTime}
      </div>
    );
  }

  return (
    <div data-cy={`${selectors.sections_collapsedField}_datetime`}>
      {startDateTime}
    </div>
  );
};
